import ApeironComponent from '@/components/commons/apeiron-component.model';
import { ActividadRetribucion, MenuGenerico } from '@/shared/model/ars/ars.model';
import CatalogosArs from '@/shared/model/ars/catalogos-ars.factory';
import { CatalogoEntidades } from '@/shared/model/catalogoEntidades.model';
import { CatalogoGenerico } from '@/shared/model/seguimiento/catalogo-generico.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { Solucion } from '@/shared/model/solucion.model';
import { SaciApi } from '@conacyt/saci-client';
import { Component, Emit, Inject, Prop } from 'vue-property-decorator';
import { required } from 'vuelidate/lib/validators';

const validations = function () {
  return {
    actividadForm: {
      nombreActividad: {
        required,
      },
      fechaRealizacion: {
        required,
      },
      fechaInicio: {
        required,
      },
      fechaTermino: {
        required,
      },
      modalidad: {
        required,
      },
      localidad: {},
      municipio: {
        required,
      },
      estado: {
        required,
      },
      region: {},
      categoria: {
        required,
      },
      subCategoria: {
        required,
      },
      problemaAtendido: {},
      objetivoActividad: {},
      descripcionAcciones: {},
    },
  };
};

/**
 */
@Component({
  validations,
})
export default class ActividadActividadArsComponent extends ApeironComponent {
  @Inject('saciApi') private readonly saciApi!: () => SaciApi;

  @Prop({ required: true })
  public readonly solucion!: Solucion;

  @Prop({ required: true })
  public readonly solicitud!: Solicitud;

  @Prop({ required: true })
  public permisos: any;

  @Prop({ required: true })
  public formModel: any;

  private guardandoSession = false;
  private iniciandoComponente = false;
  public actividadForm: ActividadRetribucion = new ActividadRetribucion();

  private consultandoSaci = false;
  private iniciandoCatalogos = false;
  public opcionesDeModalidad: Array<MenuGenerico> = [];
  public opcionesDeCategoriaRs: Array<MenuGenerico> = [];
  public opcionesDeSubategoriaRs: Array<MenuGenerico> = [];
  public opcionesEstadosGeo: Array<MenuGenerico> = [];
  public opcionesMunicipiosGeo: Array<MenuGenerico> = [];

  public mounted(): void {
    this.iniciarCatalogos();
    this.iniciarComponente();
  }

  public iniciarComponente(): void {
    this.iniciandoComponente = true;
    this.actividadForm = this.solicitud.actividadRetribucion ?? new ActividadRetribucion();

    if (!!this.actividadForm.estado) {
      this.consultarMunicipios();
    }

    this.iniciandoComponente = false;
  }

  private iniciarCatalogos(): void {
    this.iniciandoCatalogos = true;

    this.opcionesDeModalidad = CatalogosArs.obtenerModalidades().map(modalidad => new MenuGenerico(modalidad.descripcion, modalidad)) ?? [];
    this.opcionesDeCategoriaRs =
      CatalogosArs.obtenerCategoriasRetribucion().map(categoria => new MenuGenerico(categoria.descripcion, categoria)) ?? [];
    this.opcionesDeSubategoriaRs =
      CatalogosArs.obtenerSubcategorias().map(subcategoria => new MenuGenerico(subcategoria.descripcion, subcategoria)) ?? [];
    this.opcionesEstadosGeo = [];
    this.opcionesMunicipiosGeo = [];

    this.consultandoSaci = true;
    this.saciApi()
      .getAreaGeoestadisticaEstatal(1, 100)
      .then(result => {
        this.opcionesEstadosGeo = (Array.isArray(result.data) ? (result.data as CatalogoEntidades[]) : []).map(
          estado => new MenuGenerico(estado.nombre, new CatalogoGenerico(String(estado.id), estado.clave, estado.nombre))
        );
      })
      .catch(error => {
        this.opcionesEstadosGeo = [];
        if (!!error.response?.data?.detail) {
          this.alertService().showError(this, error.response.data.detail);
        } else {
          this.alertService().showHttpError(this, error.response);
        }
      })
      .finally(() => {
        this.consultandoSaci = false;
      });

    this.iniciandoCatalogos = false;
  }

  public consultarMunicipios(): void {
    if (!this.actividadForm.estado) {
      return;
    }
    this.consultandoSaci = true;
    this.actividadForm.region = CatalogosArs.obtenerRegion(this.actividadForm.estado?.clave ?? '');

    this.saciApi()
      .getMunicipiosEstado(this.actividadForm.estado?.id ?? '--', 1, 1000)
      .then(result => {
        this.opcionesMunicipiosGeo = (Array.isArray(result.data) ? (result.data as CatalogoEntidades[]) : []).map(
          estado => new MenuGenerico(estado.nombre, new CatalogoGenerico(String(estado.id), estado.clave, estado.nombre))
        );
      })
      .catch(error => {
        this.opcionesMunicipiosGeo = [];
        if (!!error.response?.data?.detail) {
          this.alertService().showError(this, error.response.data.detail);
        } else {
          this.alertService().showHttpError(this, error.response);
        }
      })
      .finally(() => {
        this.consultandoSaci = false;
      });
  }

  get consultandoElBack(): boolean {
    return this.consultandoSaci || this.iniciandoCatalogos || this.iniciandoComponente || this.guardandoSession;
  }

  get esReadOnly(): boolean {
    return this.readOnly;
  }

  @Emit('submit')
  public guardar(): { actividadRetribucion: ActividadRetribucion } {
    this.guardandoSession = true;
    return {
      actividadRetribucion: ActividadRetribucion.fromObject(this.actividadForm),
    };
  }
}
